import React, { useState } from "react"
import Container from "react-bootstrap/Container"
import { Col, Image, Row } from "react-bootstrap"
import columbiaLogo from "../images/columbiaLogo.jpg"
//import '@fortawesome/fontawesome-free/css/all.min.css';
//import 'bootstrap-css-only/css/bootstrap.min.css';

export default function Footer() {
  const [isShown, setIsShown] = useState(false)

return (
  <Container fluid className="containerFooter">
    <Row
      style={{
        display: "fluid",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Col
        xs={12}
        md={6}
        style={{
          display: "fluid",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
<div
  onMouseEnter={() => setIsShown(true)}
  onMouseLeave={() => setIsShown(false)}
>
  {isShown === false && (

        <Image src={columbiaLogo} alt="" style={{ margin: "auto", opacity: "80%"}}
               onClick={() => {
                 window.open("https://www.columbia.edu")
               }}
        /> )}
  {isShown === true && (

    <Image src={columbiaLogo} alt="" style={{ margin: "auto", opacity: "60%", cursor: "pointer" }}
           onClick={() => {
             window.open("https://www.columbia.edu")
           }}
    /> )}

</div>
      </Col>
      <Col
        xs={12}
        md={6}
        style={{
          display: "fluid",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >

        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://zuckermaninstitute.columbia.edu">


          <h1 style={{ textAlign: "center", color: "white" }}>
            Zuckerman Mind Brain Behaviour Institute
          </h1>
        </a>
        <p style={{ textAlign: "center", color: "white" }}>
          Jerome L. Greene Science Center
        </p>
        <p style={{ textAlign: "center", color: "white" }}>
          Columbia University
        </p>
        <p style={{ textAlign: "center", color: "white" }}>New York</p>
      </Col>
    </Row>
  </Container> )
//)
}

//export default Footer
